import { render } from "./agent-share.vue?vue&type=template&id=968e27b0"
import script from "./agent-share.vue?vue&type=script&lang=js"
export * from "./agent-share.vue?vue&type=script&lang=js"

import "./agent-share.vue?vue&type=style&index=0&id=968e27b0&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-banner/standard/agent-share.vue'],['render',render],['__file',"agent-share.vue"]])

export default __exports__